import React, { useState } from "react";
import StudentHeader from "../components/StudentHeader";
import Footer from "../components/Footer";
import {Container,Card,Form,Button,Modal,Tab,Tabs,} from "react-bootstrap";
import { FaEye, FaTrashAlt, FaUndoAlt } from "react-icons/fa";
import { DataGrid } from "@mui/x-data-grid";
import Chip from "@mui/material/Chip";

const SchoolRequests = () => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [key, setKey] = useState();
    const columns = [
        { field: "id", headerName: "ID", sortable: false, width: 70 },
        { field: "school", headerName: "School", sortable: false, width: 200 },
        {
            field: "department",
            headerName: "Type of rotation",
            sortable: false,
            width: 200,
        },
        {
            field: "date",
            headerName: "Date",
            sortable: false,
            width: 215,
        },
        {
            field: "hours",
            headerName: "Time",
            sortable: false,
            width: 185,
        },
        {
            field: "status",
            headerName: "Approval Status",
            sortable: false,
            width: 150,
            renderCell: (params) => {
                return (
                    <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                    >
                        <Chip
                            label="Under review"
                            size="small"
                            color="primary"
                        />
                    </div>
                );
            },
        },
        {
            field: "action",
            headerName: "Action",
            sortable: false,
            width: 150,
            renderCell: (params) => {
                return (
                    <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                    >
                        <Button
                            variant="success"
                            size="sm"
                            href="/school-dashboard"
                        >
                            Accept
                        </Button>{" "}
                        <Button variant="danger" size="sm" className="ms-2">
                            Reject
                        </Button>
                    </div>
                );
            },
        },
    ];

    const rows = [
        {
            id: 1,
            school: "Azusa Pacific University",
            department: "Medical",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Under review",
        },
        {
            id: 2,
            school: "Grand Canyon University",
            department: "Surgical",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Under review",
        },
        {
            id: 3,
            school: "Cal Baptist University",
            department: "Mental Health",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Under review",
        },
        {
            id: 4,
            school: "UCLA",
            department: "Pediatrics",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Rejected",
        },
        {
            id: 5,
            school: "CSULB",
            department: "OB",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Rejected",
        },
    ];

    const columns1 = [
        { field: "id", headerName: "ID", sortable: false, width: 70 },
        { field: "school", headerName: "School", sortable: false, width: 200 },
        {
            field: "department",
            headerName: "Type of rotation",
            sortable: false,
            width: 200,
        },
        {
            field: "date",
            headerName: "Date",
            sortable: false,
            width: 215,
        },
        {
            field: "hours",
            headerName: "Time",
            sortable: false,
            width: 185,
        },
        {
            field: "status",
            headerName: "Approval Status",
            sortable: false,
            width: 150,
            renderCell: (params) => {
                return (
                    <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                    >
                        <Chip label="Accepted" size="small" color="success" />
                    </div>
                );
            },
        },
        {
            field: "action",
            headerName: "Action",
            sortable: false,
            width: 150,
            renderCell: (params) => {
                return (
                    <div className="" style={{ cursor: "pointer" }}>
                        <span className="actn_icn" onClick={handleShow}>
                            <FaEye title="View" />
                        </span>
                    </div>
                );
            },
        },
    ];

    const rows1 = [
        {
            id: 1,
            school: "Azusa Pacific University",
            department: "Medical",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Under review",
        },
        {
            id: 2,
            school: "Grand Canyon University",
            department: "Surgical",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Under review",
        },
        {
            id: 3,
            school: "Cal Baptist University",
            department: "Mental Health",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Under review",
        },
        {
            id: 4,
            school: "UCLA",
            department: "Pediatrics",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Rejected",
        },
        {
            id: 5,
            school: "CSULB",
            department: "OB",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Rejected",
        },
    ];

    return (
        <div className="dashbrd_pg">
            <StudentHeader />
            <div className="schl_prfl_pg">
                <Container className="custm_container">
                    <div className="prfl_wrap">
                        <div className="pg_hdng mb-4">
                            <h2>School Requests</h2>
                        </div>
                        <Card className="pg_card">
                            <Card.Body>
                                {/* <div className="card_hdng ">
                                    <h4 className="mb-0">School Requests</h4>
                                </div> */}
                                <div className="prfl_tabs">
                                    <Tabs
                                        defaultActiveKey="home"
                                        id="uncontrolled-tab-example"
                                        className="mb-3"
                                        activeKey={key}
                                        onSelect={(k) => setKey(k)}
                                    >
                                        <Tab
                                            eventKey="home"
                                            title="New Requests"
                                        >
                                            <div className="apprvl_list">
                                                <div
                                                    style={{
                                                        height: 400,
                                                        width: "100%",
                                                    }}
                                                >
                                                    <DataGrid
                                                        rows={rows}
                                                        columns={columns}
                                                        pageSize={5}
                                                        rowsPerPageOptions={[5]}
                                                    />
                                                </div>
                                            </div>
                                        </Tab>

                                        <Tab
                                            eventKey="profile"
                                            title="Past Bookings"
                                        >
                                            {key === "profile" && (
                                                <div className="apprvl_list">
                                                    <div
                                                        style={{
                                                            height: 400,
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <DataGrid
                                                            rows={rows1}
                                                            columns={columns1}
                                                            pageSize={5}
                                                            rowsPerPageOptions={[
                                                                5,
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </Tab>
                                    </Tabs>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </Container>
            </div>
            <Footer />

            <Modal show={show} onHide={handleClose} className="main_modl">
                <Modal.Header closeButton>
                    <Modal.Title className="text_theme">
                        Request Detail
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="dbbsc_info p-2 rttn_info">
                        <p className="stdntbsc_inf">
                            <strong>School:</strong> Azusa Pacific University
                        </p>
                        <p className="stdntbsc_inf">
                            <strong>Rotation Type:</strong> Medical
                        </p>
                        <p className="stdntbsc_inf">
                            <strong>Date:</strong> 12/11/2022 - 18/11/2022
                        </p>
                        <p className="stdntbsc_inf">
                            <strong>Time:</strong> 9 a.m.-6 p.m.
                        </p>
                        <p className="stdntbsc_inf">
                            <strong>Course Objective:</strong> Lorem ipsum
                        </p>
                        <p className="stdntbsc_inf">
                            <strong>Message:</strong> Lorem ipsum dolor sit
                            amet, consectetur adipisicing elit. Repellendus
                            architecto dolor totam.
                        </p>
                        <p className="stdntbsc_inf">
                            <strong>Approval Status:</strong>{" "}
                            <Chip
                                label="Accepted"
                                color="success"
                                size="small"
                                className="schl_bdg"
                            />
                        </p>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default SchoolRequests;
